module.exports = __webpack_public_path__ + "img/home.7d99173c.png";